import { FieldOption } from './accountTypes'

const webinarMediaTypes: FieldOption[] = [
  { name: 'Transcript', value: 'transcript' },
  { name: 'Audio', value: 'audio' },
  { name: 'Video', value: 'video' },
  { name: 'Deck', value: 'deck' },
  { name: 'None', value: null }
]

export default webinarMediaTypes
